module.exports = {
  strings: {
    pluginNameBox: 'Box'
  }
};